import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";

import { Subscription } from "rxjs";
import { RecordStateEnum } from "src/app/shared/enums";

import { TextConstants } from "@shared/constants";
import { ISelectOption } from "@shared/interfaces";

@Component({
  standalone: false,
  selector: "app-search-and-archive-filter",
  templateUrl: "./search-and-archive-filter.component.html",
  styleUrls: ["./search-and-archive-filter.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchAndArchiveFilterComponent implements OnInit, OnDestroy {
  @Input()
  public searchText: string = null;

  @Input()
  public isRecordStateFilterEnabled: boolean = true;

  @Input()
  public recordState: RecordStateEnum = RecordStateEnum.ALL;

  @Input()
  public canClearSelection: boolean = false;

  @Output()
  public searchChanged: EventEmitter<string> = new EventEmitter();

  @Output()
  public recordStateChanged: EventEmitter<RecordStateEnum> = new EventEmitter();

  public formGroup: UntypedFormGroup = new UntypedFormGroup({});

  public readonly recordStateOptions: ISelectOption[] = [
    { label: $localize`:@@shared.all:All`, value: RecordStateEnum.ALL },
    { label: $localize`:@@shared.active:Active`, value: RecordStateEnum.ACTIVE },
    { label: TextConstants.ARCHIVED, value: RecordStateEnum.ARCHIVED },
  ];

  public readonly translations: any = {
    searchPlaceholder: `${TextConstants.SEARCH}...`,
    recordStateLabel: TextConstants.STATUS,
  };

  private readonly subscriptions = new Subscription();

  public async ngOnInit() {
    this.formGroup = new UntypedFormGroup({
      recordState: new UntypedFormControl(this.recordState),
    });

    if (!this.isRecordStateFilterEnabled) {
      return;
    }

    this.subscriptions.add(
      this.formGroup
        .get("recordState")
        .valueChanges.subscribe(async (recordState: RecordStateEnum) => {
          this.recordStateChanged.emit(
            recordState === RecordStateEnum.ALL ? undefined : recordState,
          );
        }),
    );
  }

  public onSearch = async (value: string): Promise<void> => {
    this.searchChanged.emit(value.trim());
  };

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
